import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rightContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    versionContainer: {
        justifyContent: "center",
        alignItems: "center",
        width: "100%"
    }
});
export default stylesheet;
